import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: `.swiper-button-next-${sliderIdentifier}`,
            prevEl: `.swiper-button-prev-${sliderIdentifier}`
        },
        scrollbar: {
            el: `.swiper-scrollbar-${sliderIdentifier}`,
            draggable: true,
        },
        breakpoints: {
            300: {
                spaceBetween: 20,
            },
            768: {
                spaceBetween: 0,
            },
        },
    });
}

const allSliders = $('.numbers-slider.swiper-container');

allSliders.each((index, element) => buildSwiperSlider(element));
